import { render, staticRenderFns } from "./passwordRecovery.vue?vue&type=template&id=0bb3a3a0&"
import script from "./passwordRecovery.vue?vue&type=script&lang=js&"
export * from "./passwordRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports